export const onDialogExited = dialogType => ({
  widget: 'entries',
  type: 'onDialogExited',
  payload: { dialogType },
})



// WEBPACK FOOTER //
// ./src/entries/actions/onDialogExited.js